import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  academyTopicSelector,
  setOtherInstructors,
} from 'features/classCreation';
import ScheduleInstructorSelect from '../ScheduleInstructorSelect';

function OtherInstructorsSelect({ cls }) {
  const dispatch = useDispatch();
  const academyTopic = useSelector((state) =>
    academyTopicSelector(state, cls.academy_topic.id)
  );

  const handleChange = useCallback(
    (value) => {
      dispatch(
        setOtherInstructors({
          academyTopicId: cls.academy_topic.id,
          instructors: value,
        })
      );
    },
    [cls.academy_topic.id, dispatch]
  );

  if (academyTopic?.isInstructorRequired) {
    return (
      <ScheduleInstructorSelect
        isMulti
        academyTopic={academyTopic}
        onChange={handleChange}
        placeholder="Add Other Instructor(s)"
        value={academyTopic?.otherInstructors || []}
      />
    );
  } else {
    return <div className="hint p-h-xxs">N/A</div>;
  }
}

export default OtherInstructorsSelect;
